/**
 * Web Style Import
 *
 */

import './style/dnb-heading.scss'
